const sortWrapper = document.querySelector('[data-sort-wrapper]')
if (sortWrapper) {
  const trigger = sortWrapper.querySelector('[data-sort-trigger]')
  const options = sortWrapper.querySelector('[data-sort-options]')

  function open() {
    options.hidden = false
    trigger.setAttribute('aria-expanded', 'true')
  }

  function close() {
    options.hidden = true
    trigger.setAttribute('aria-expanded', 'false')
  }

  trigger.addEventListener('click', () => {
    options.hidden ? open() : close()
  })

  options.addEventListener('click', (e) => {
    const li = e.target.closest('[data-sort-value]')
    if (!li) return
    const value = li.dataset.sortValue
    const url = new URL(globalThis.location.href)
    url.searchParams.set('sort_by', value)
    globalThis.location.href = url.toString()
  })

  options.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return
    e.preventDefault()
    const li = e.target.closest('[data-sort-value]')
    if (!li) return
    li.click()
  })

  document.addEventListener('click', (e) => {
    if (!sortWrapper.contains(e.target)) close()
  })

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close()
  })
}
